import React, { useState } from "react";
import { Helmet } from "react-helmet";
import Header from "../../components/common/Header";
import Footer from "../../components/common/Footer";

import ContactSection from "../../components/common/ContactSection";
import ResearchHero from "./ResearchHero";
import PreAnalyticalControls from "./PreAnalyticalControls";
import EthicalSourcing from "./EthicalSourcing";
import SampleAccountability from "../../components/common/SampleAccountability";
import {
  Database,
  Bell,
  FileText,
  ShieldCheck,
  QrCode,
  Siren,
  Check,
} from "lucide-react";
import ProcurementOptions from "../../components/common/ProcurementOptions";

const QualityAndCompliance = () => {
  // Changed: Initial state is null (nothing open)
  const [openIndex, setOpenIndex] = useState(null);

  const toggleExpanded = (index) => {
    // If clicking the same item, close it (null). Otherwise, open the new index.
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };
  const accountabilityData = [
    {
      icon: QrCode,
      title: "Safe Harbor De-identification",
      description:
        "Direct identifiers are permanently removed and replaced with unique coded identifiers.",
    },
    {
      icon: Siren,
      title: "Temporal Data Shifting",
      description:
        "Dates are shifted to protect privacy while preserving critical clinical relationships.",
    },
    {
      icon: FileText,
      title: "Secure Data Vaults",
      description:
        "Identifying info is stored in encrypted, access-controlled databases separate from specimens.",
    },
  ];

  const customData2 = [
    {
      title: "Physical Security",
      description:
        "24/7 monitored facilities with biometric access control and disaster recovery protocols for sample preservation. ",
    },
    {
      title: "Data Security",
      description:
        "AES-256 encryption at rest and in transit, with regular third-party penetration testing and vulnerability assessments.",
    },
    {
      title: "Confidentiality",
      description:
        "Comprehensive NDAs and internal data handling policies that ensure your proprietary research stays private.",
    },
  ];
  return (
    <>
      <Helmet>
        <title>ANVIYA Biospecimen Services</title>
      </Helmet>

      <main className="w-full bg-white">
        <Header />

        <ResearchHero />
        <EthicalSourcing />
        <SampleAccountability
          title="Protecting Donor Privacy"
          discription="We implement multi-layered de-identification strategies to ensure complete anonymity while preserving research utility."
          features={accountabilityData}
          imageSrc="/images/BiostorageImg/DonorImg.png"
        />
        <PreAnalyticalControls />
        <ProcurementOptions
          title="What We Can Deliver"
          descriptionTitle="Every ANVIYA biospecimen meets stringent quality and ethical standards:"
          options={customData2}
          icon={Check} // Optional: Changes the icon for all cards
        />
        <ContactSection />
        <Footer />
      </main>
    </>
  );
};

export default QualityAndCompliance;
